import vis from 'vis';
var FieldDefs = {};
FieldDefs.Base = function() { this.init.apply(this, arguments); };
FieldDefs.Base.prototype = {
  dom_id: null,
  question: null,
  explaination: null,
  attachments: null,
  attachment_ids: null,
  _type: null,
  active: null,
  getDefaultMCOptions: function() {
    var ko_options = [];
    for(var i = 0; i < 4; i++) {
      ko_options.push({answer: ko.observable(''), selected: ko.observable(false)});
    }
    return ko_options;
  },
  getDefaultTFOptions: function() {
    var ko_options = [];
    ko_options.push({answer: ko.observable('True'), selected: ko.observable(false)});
    ko_options.push({answer: ko.observable('False'), selected: ko.observable(false)});
    return ko_options;
  },
  getOptions: function(options) {
    var ko_options = [];
    if (options.length > 0) {
      for(var i = 0; i < options.length; i++) {
        ko_options.push({answer: ko.observable(options[i].answer), selected: ko.observable(options[i].selected)});
      }
    } else {
      if (this._type() == 'MultipleChoiceField')
        ko_options = this.getDefaultMCOptions();
      else if (this._type() == 'TrueFalseField')
        ko_options = this.getDefaultTFOptions();
    }
    return ko_options;
  },
  addOption: function(item, event) {
    this.options.push({answer: ko.observable(''), selected: ko.observable(false)});
  },
  deleteOption: function(item, event) {
    this.options.remove(function(option) {
      return option === item;
    });
    this.refreshSelectedOption();
  },
  resetOptions: function () {
    _.each(this.options(), function(option) {
      option.selected(false);
    });
    this.selected_option(null);
    this.selected_option.isModified(false);
  },
  getSelectedOption: function(options) {
    var selected_option = null;
    $.each(options, function(index, option) {
      if(option.selected() == true) {
        selected_option = option;
      }
    });
    return selected_option;
  },
  refreshSelectedOption: function () {
    var opt = this.getSelectedOption(this.options());
    this.selected_option(opt);
    return true;
  },
  getAnswerCollection: function(answer_collection) {
    var ko_answer_collection = [];
    if (answer_collection.length > 0) {
      for(var i = 0; i < answer_collection.length; i++) {
        ko_answer_collection.push({answers: ko.observable(answer_collection[i].answers), times: ko.observable(answer_collection[i].times)});
      }
    }
    return ko_answer_collection;
  },
  addAnswerCollection: function(item, event) {
    if (this._type() == 'FillInTheBlankField' || this._type() == 'WrittenResponseField') {
      this.answer_collection.push({answers: ko.observable(''), times: ko.observable(1)});
    } else if (this._type() == 'AnswerBuilderField') {
      this.answer_collection.push({answers: ko.observable('')});
    }
  },
  deleteAnswerCollection: function(item, event) {
    this.answer_collection.remove(function(collection) {
      return collection === item;
    });
  },
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;

    this.dom_id = ko.observable(dom_id);
    this.question = ko.observable(r(fd, 'question', ''));
    this.explaination = ko.observable(r(fd, 'explaination', ''));
    this.attachments = ko.observableArray(r(fd, 'attachments', []));
    this.attachment_ids = ko.observableArray(r(fd, 'attachment_ids', []));
    this._type = ko.observable(r(fd, '_type', ''));
    this.active = ko.observable(!_.isEmpty(opts) && opts['isActive'] || false);
  }
};
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.FillInTheBlankField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.FillInTheBlankField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  answer: null,
  answer_collection: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    var answer_collection = r(fd, 'answer_collection', []);
    var ko_answer_collection = FieldDefs.Base.prototype.getAnswerCollection(answer_collection);
    this.answer = ko.observable(r(fd, 'answer', ''));
    this.answer_collection = ko.observableArray(ko_answer_collection);
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.WrittenResponseField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.WrittenResponseField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  answer: null,
  answer_collection: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    var answer_collection = r(fd, 'answer_collection', []);
    var ko_answer_collection = FieldDefs.Base.prototype.getAnswerCollection(answer_collection);

    this.answer = ko.observable(r(fd, 'answer', ''));
    this.answer_collection = ko.observableArray(ko_answer_collection);
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.MultipleChoiceField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.MultipleChoiceField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  options: null,
  selected_option: null,
  multi_response: null,
  grading_format: null,
  init: function(dom_id, fd, opts) {
    var self = this;
    var r = Kadenze.Util.objFromString;
    var options = r(fd, 'options', []);
    var ko_options = FieldDefs.Base.prototype.getOptions.call(this, options);

    this.options = ko.observableArray(ko_options);
    this.multi_response = ko.observable(r(fd, 'multi_response', false));
    this.grading_format = ko.observable(r(fd, 'grading_format'));

    if (opts['isSurvey']) {
      this.selected_option = ko.observable();
    } else {
      var so = FieldDefs.Base.prototype.getSelectedOption(ko_options);
      this.selected_option = ko.observable(so).extend({ required: { message: Kadenze.I18n.t('form_builder.multiple_choice_option_validation') } });
      this.multi_response.subscribe(function () {
        self.resetOptions();
        //Select partial as the default grading format for multi select if none is selected
        if (self.multi_response() && _.isEmpty(self.grading_format())) {
          self.grading_format('partial');
        }
      });
    }
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.TrueFalseField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.TrueFalseField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  options: null,
  selected_option: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    var options = r(fd, 'options', []);
    var ko_options = FieldDefs.Base.prototype.getOptions.call(this, options);

    this.options = ko.observable(ko_options);
    if (opts['isSurvey']) {
      this.selected_option = ko.observable();
    } else {
      var so = FieldDefs.Base.prototype.getSelectedOption(ko_options);
      this.selected_option = ko.observable(so).extend({ required: { message: Kadenze.I18n.t('form_builder.multiple_choice_option_validation') } });
    }
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.RatingField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.RatingField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  scale: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    this.scale = ko.observable(r(fd, 'scale', ''));
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.AnswerBuilderField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.AnswerBuilderField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  correct_answers: null,
  incorrect_answers: null,
  answer_collection: null,
  answers_expected: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    var answer_collection = r(fd, 'answer_collection', []);
    var ko_answer_collection = [];
    if (answer_collection.length > 0) {
      for(var i = 0; i < answer_collection.length; i++) {
        ko_answer_collection.push({answers: ko.observable(answer_collection[i].answers)});
      }
    } else {
      ko_answer_collection.push({answers: ko.observable('')});
    }

    this.correct_answers = ko.observable(r(fd, 'correct_answers', ''));
    this.incorrect_answers = ko.observable(r(fd, 'incorrect_answers', ''));
    this.answer_collection = ko.observableArray(ko_answer_collection);
    this.answers_expected = ko.observable(r(fd, 'answers_expected', 1));
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.TimelineField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.TimelineField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  start_date: null,
  end_date: null,
  milestones: null,
  addMilestone: function(item, event) {
    this.milestones.push(ko.observable(''));
  },
  deleteMilestone: function(item) {
    this.milestones.remove(function(milestone) {
      return milestone === item;
    });
  },
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    var milestones = r(fd, 'milestones', []);
    var ko_milestones = [];
    if (milestones.length > 0) {
      for(var i = 0; i < milestones.length; i++) {
        ko_milestones.push(ko.observable(milestones[i]));
      }
    } else {
      ko_milestones.push(ko.observable(''));
    }

    this.start_date = ko.observable(r(fd, 'start_date', ''));
    this.end_date = ko.observable(r(fd, 'end_date', ''));
    this.milestones = ko.observableArray(ko_milestones);
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.InteractiveTimelineField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.InteractiveTimelineField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  milestones: null,
  midpoint: null,
  granularity: null,
  zoom_min: null,
  vis_dataset: null,
  ko_dataset: null,
  grading_format: null,
  init: function(dom_id, fd, opts) {
    var self = this;
    var r = Kadenze.Util.objFromString;

    this.milestones = _.compact(r(fd, 'milestones', []));
    this.ko_dataset = ko.observableArray();
    this.granularity = ko.observable(r(fd, 'granularity', 'year'));
    this.grading_format = ko.observable(r(fd, 'grading_format', 'partial'));

    this.milestone_text_input = ko.observable('');
    this.milestone_date_input = ko.observable('');
    this.milestone_replace_image = ko.observable(false);
    this.milestone_image_staged = ko.observable(false);

    this.milestone_item = null;
    this.milestone_callback = null;
    this.zoom_min = ko.computed(function () {
      var zoomMin;
      switch (self.granularity()) {
      case 'century':
        zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 1000;
        break;
      case 'decade':
        zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 100;
        break;
      case 'year':
        zoomMin = 1000 * 60 * 60 * 24 * 30 * 12 * 10;
        break;
      case 'month':
        zoomMin = 1000 * 60 * 60 * 24 * 30 * 12;
        break;
      case 'day':
        zoomMin = 1000 * 60 * 60 * 24 * 30;
        break;
      default:
        zoomMin = 1000 * 60 * 60 * 24 * 30;
      }
      return zoomMin;
    });
    this.zoom_min.subscribe(function (newVal) {
      self.saveTimeline();
      self.initTimeline();
    });
    this.datepicker_opts = ko.computed(function () {
      var opts = {};
      switch (self.granularity()) {
      case 'century':
        opts = {minViewMode: 'centuries', format: 'yyyy', autoclose: true};
        break;
      case 'decade':
        opts = {minViewMode: 'decades', format: 'yyyy', autoclose: true};
        break;
      case 'year':
        opts = {minViewMode: 'years', format: 'yyyy', autoclose: true};
        break;
      case 'month':
        opts = {minViewMode: 'months', format: 'mm/yyyy', autoclose: true};
        break;
      case 'day':
      default:
        opts = {minViewMode: 'days', format: 'mm/dd/yyyy', autoclose: true};
      }
      return opts;
    });
    this.datepicker_opts.subscribe(function (value) {
      self.refreshMilestoneListing();
    });
    this.midpoint = ko.computed(function () {
      if (self.ko_dataset().length > 0) {
        var milestones = _.sortBy(self.ko_dataset(), function (milestone) {
          return new Date(milestone.start());
        });
        var dateMin = new Date(milestones[0].start());
        var dateMax = new Date(milestones[milestones.length - 1].start());
        return moment((dateMin.getTime() + dateMax.getTime()) / 2).format();
      } else {
        return r(fd, 'midpoint', moment().format());
      }
    });
  },
  initTimeline: function () {
    // create some items
    // note that months are zero-based in the JavaScript Date object, so month 4 is May
    var self = this;
    this.ko_dataset([]);
    this.vis_dataset = new vis.DataSet();
    this.vis_dataset.on('*', function (event, properties, senderId) {
      switch(event) {
      case 'add':
        _.each(properties.items, function (id) {
          var milestone = ko.mapping.fromJS(_.extend({}, {attachment_id: null, attachment: {}}, self.vis_dataset.get(id)));
          milestone.computed_start = ko.computed({
            read: function () {
              return moment(milestone.start()).format();
            },
            write: function (value) {
              var date = moment(value, self.datepicker_opts().format.toUpperCase()).toISOString();
              var item = self.vis_dataset.get(id);
              item.start = date;
              self.vis_dataset.update(item);
              self.saveTimeline();
            }
          });
          self.ko_dataset.push(milestone);
        });
        break;
      case 'update':
        _.each(properties.data, function (updatedMilestone) {
          var milestone = ko.utils.arrayFirst(self.ko_dataset(), function(m) {
            return m.id() == updatedMilestone.id;
          });
          if (milestone) {
            _.each(_.keys(updatedMilestone), function (key) {
              var val = ko.isObservable(updatedMilestone[key]) ? updatedMilestone[key]() : updatedMilestone[key];
              if (ko.isObservable(milestone[key])) {
                milestone[key](val);
              } else {
                milestone[key] = val;
              }
            });
          }
        });
        self.refreshMilestoneListing();
        break;
      case 'remove':
        _.each(properties.items, function (id) {
          self.ko_dataset.remove(function(item) {
            return item.id() == id;
          });
        });
        break;
      }
    });
    this.vis_dataset.add(this.milestones);

    // create visualization
    var $container = $('#' + this.dom_id());
    var $timeline = $container.find('#js-timeline');
    $timeline.html('');

    var options = {
      editable: true,
      customAction: {
        title: 'Edit this item',
        className: 'vis-edit',
        onClick: _.bind(this.viewMilestone, this)
      },
      height: '400px',
      onAdd: _.bind(this.addMilestoneInternal, this),
      onUpdate: _.bind(this.updateMilestone, this),
      onMove: _.bind(this.moveMilestone, this),
      onRemove: _.bind(this.removeMilestone, this),
      min: moment('0001'),
      zoomable: true,
      zoomMin: this.zoom_min(),
      zoomMax: 1000 * 60 * 60 * 24 * 30 * 12 * 1000, //Century
      template: JST['templates/dynamic_fields/authoring/interactive_timeline_milestone'],
      format: this.getTimelineFormatObj(),
      snap: _.bind(this.getSnappedDate, this)
    };

      // create the timeline
    var vis_timeline = new vis.Timeline($timeline[0]);
    vis_timeline.setOptions(options);
    vis_timeline.setItems(this.vis_dataset);
    vis_timeline.on('select',this.milestoneSelect);
    setTimeout(function () {
      vis_timeline.zoomIn(1);
    }, 300);

    // store obj in DOM
    $.data($timeline[0], 'vis_timeline', vis_timeline);
  },
  refreshMilestoneListing: function() {
    //Force ko to re-render milestone listing and it's datepickers
    var data = this.ko_dataset.slice(0);
    this.ko_dataset([]);
    this.ko_dataset(data);
  },
  milestoneSelect: function(properties, event) {
    var self = this;
    //Reset previously selected milestones
    this.itemSet.itemsData.forEach(function (item) {
      self.itemSet.itemsData.update(_.extend({}, item, {selected: false}));
    }, {filter: function (item) { return (item.selected == true); }});
    //Mark this milestones as selected
    if (properties.items.length > 0) {
      var id = properties.items[0];
      var item = this.itemSet.itemsData.get(id);
      this.itemSet.itemsData.update(_.extend({}, item, {selected: true}));
    }
    this.redraw();
  },
  getTimelineFormatObj: function () {
    return {
      minorLabels: function (date, scale, step) {
        var label = '';
        var defaultFormats = {
          millisecond:'SSS',
          second:     's',
          minute:     'HH:mm',
          hour:       'HH:mm',
          weekday:    'ddd D',
          day:        'D',
          month:      'MMM',
          year:       'YYYY'
        };
        if (scale == 'year' && step == 100) {
          var year = parseInt(date.year()) / 100;
          var century = year + 1;
          label = Kadenze.Util.getOrdinal(century) + ' Century';
        } else {
          label = date.format(defaultFormats[scale]);
        }
        return label;
      },
      majorLabels: function (date, scale, step) {
        var date = moment(date);
        var label = '';
        var defaultFormats = {
          millisecond:'HH:mm:ss',
          second:     'D MMMM HH:mm',
          minute:     'ddd D MMMM',
          hour:       'ddd D MMMM',
          weekday:    'MMMM YYYY',
          day:        'MMMM YYYY',
          month:      'YYYY',
          year:       ''
        };
        if (scale == 'year' && step >= 1 && step <= 5) {
          //Show decade
          var decade = Math.floor(parseInt(date.year() / 10)) * 10;
          label = decade + '\'s';
        } else if (scale == 'year' && step >= 10 && step <= 50) {
          //Show century
          var century = Math.floor(parseInt(date.year()) / 100) + 1;
          label = Kadenze.Util.getOrdinal(century) + ' Century';
        } else if (!_.isEmpty(defaultFormats[scale])) {
          label = date.format(defaultFormats[scale]);
        }
        return label;
      }
    };
  },
  getSnappedDate: function (date, scale, step) {
    var clone = moment(date);
    if (scale == 'year') {
      var modifiedStep;
      switch (this.granularity()) {
      case 'century':
        modifiedStep = 100;
        break;
      case 'decade':
        modifiedStep = 10;
        break;
      case 'year':
        modifiedStep = 1;
        break;
      }
      var year = clone.year() + Math.round(clone.month() / 12);
      clone.year(Math.round(year / modifiedStep) * modifiedStep);
      clone.month(0);
      clone.date(1);
      clone.hours(0);
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    } else if (scale == 'month') {
      if (clone.date() > 15) {
        clone.date(1);
        clone.add(1, 'month');
      } else {
        clone.date(1);
      }
      clone.hours(0);
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    } else if (scale == 'day') {
      switch (step) {
      case 5:
      case 2:
        clone.hours(Math.round(clone.hours() / 24) * 24);
        break;
      default:
        clone.hours(Math.round(clone.hours() / 12) * 12);
        break;
      }
      clone.minutes(0);
      clone.seconds(0);
      clone.milliseconds(0);
    }
    return clone;
  },
  getFormattedDate: function (item) {
    var date = '';
    switch (this.granularity()) {
    case 'century':
      var century = Math.floor(parseInt(moment(item.start()).year()) / 100) + 1;
      date = Kadenze.Util.getOrdinal(century) + ' Century';
      break;
    case 'decade':
      var decade = Math.floor(parseInt(moment(item.start()).year() / 10)) * 10;
      date = decade + '\'s';
      break;
    case 'year':
    case 'month':
    case 'day':
    default:
      date = moment(item.start()).format(this.datepicker_opts().format.toUpperCase()).toString();
    }
    return date;
  },
  getTimlineObj: function() {
    var $container = $('#' + this.dom_id());
    var $timeline = $container.find('#js-timeline');
    var vis_timeline = $.data($timeline[0], 'vis_timeline');
    return vis_timeline;
  },
  zoomIn: function () {
    var vis_timeline = this.getTimlineObj();
    vis_timeline.zoomIn(1);
  },
  zoomOut: function () {
    var vis_timeline = this.getTimlineObj();
    vis_timeline.zoomOut(1);
  },
  goToCurrent: function () {
    var vis_timeline = this.getTimlineObj();
    vis_timeline.moveTo(new Date());
  },
  addMilestoneExternal: function () {
    //Triggered by FAB button
    var self = this;
    var uuid = Kadenze.Util.generateUUID();
    var window = self.getTimlineObj().getWindow();
    var date = moment((window.start.getTime() + window.end.getTime()) / 2);
    this.milestone_item = {start: date, content: null, id: uuid};
    this.milestone_callback = function (item) {
      self.vis_dataset.add(item);
    };
    this.milestone_date_input(this.milestone_item.start.format());
    this.showAddModal();
  },
  addMilestoneInternal: function (item, callback) {
    //Triggered by plugin
    this.milestone_item = item;
    this.milestone_callback = callback;
    this.milestone_date_input(moment(this.milestone_item.start).format());
    this.showAddModal();
  },
  updateMilestone: function (item, callback) {
    this.milestone_item = item;
    this.milestone_callback = callback;
    this.milestone_date_input(moment(this.milestone_item.start).format());
    this.showEditModal();
  },
  moveMilestone: function (item, callback) {
    callback(item);
    this.saveTimeline();
  },
  viewMilestone: function (item) {
    //Triggered by plugin
    var itemData = item.parent.itemSet.itemsData.get(item.id);
    item.parent.itemSet.options.onUpdate(itemData, function (itemData) {
      if (itemData) {
        item.parent.itemSet.itemsData.getDataSet().update(itemData);
      }
    });
  },
  viewMilestoneExternal: function (data) {
    //Triggered by edit button in milestone listing
    var itemData = ko.mapping.toJS(data);
    var timeline = $.data($('#js-timeline')[0], 'vis_timeline');
    timeline.itemSet.options.onUpdate(itemData, function (itemData) {
      if (itemData) {
        timeline.itemSet.itemsData.getDataSet().update(itemData);
      }
    });
  },
  removeMilestone: function (item, callback) {
    var self = this;
    Kadenze.UIUtil.confirmAction('Are you sure you want to remove this milestone?', function () {
      callback(item); // confirm deletion
      self.saveTimeline();
    }, function () {
      callback(null);
    });
  },
  removeMilestoneExternal: function (data) {
    var itemData = ko.mapping.toJS(data);
    var timeline = $.data($('#js-timeline')[0], 'vis_timeline');
    timeline.itemSet.options.onRemove(itemData, function (itemData) {
      if (itemData) {
        timeline.itemSet.itemsData.getDataSet().remove(itemData.id);
      }
    });
  },
  saveTimeline: function () {
    this.milestones = this.vis_dataset.get({
      type: {
        start: 'ISODate',
        end: 'ISODate'
      }
    });
  },
  initImageAddDropZone: function() {
    var self = this;
    var $container = $('#add-milestone-' + self.dom_id());
    var $dropArea = $('#dz-milestone-image-drop-' + self.dom_id());
    var fileTypes = '.jpg, .jpeg, .png';
    var message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.milestone_image_file_title'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    var opts = {
      autoProcessQueue: true,
      paramName: 'attachment[file]',
      acceptedFiles: fileTypes,
      previewsContainer: '#dz-milestone-image-preview-' + self.dom_id(),
      maxFiles: 1
    };

    var callbacks = {
      addedfile: function () {
        self.milestone_image_staged(true);
      },
      removedfile: function () {
        self.milestone_image_staged(false);
      },
      sending: function(file, xhr, formData) {
        Kadenze.UIUtil.showLoadingIndicator($container);
      },
      success: function(file, response) {
        if(response.files[0]) {
          file.id = response.files[0].id;
          self.milestone_item.attachment = response.files[0];
          self.milestone_item.attachment_id = file.id;
        }
      },
      error: function(file, errorMessage) {
        Kadenze.UIUtil.showNotice($container, {message: errorMessage}, 1000);
      },
      complete: function(file) {
        Kadenze.UIUtil.hideLoadingIndicator($container);
      }
    };

    return Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);
  },
  initImageEditDropZone: function($container) {
    var self = this;
    var $dropArea = $('#dz-' + 'edit-drop-' + self.milestone_item.id);
    var fileTypes = '.jpg, .jpeg, .png';
    var message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.milestone_image_file_title'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    var opts = {
      url: (self.milestone_item.attachment_id ? Kadenze.Routes.attachment_path(self.milestone_item.attachment_id) : Kadenze.Routes.attachments_path()),
      method: (self.milestone_item.attachment_id ? 'PUT' : 'POST'),
      autoProcessQueue: true,
      paramName: 'attachment[file]',
      acceptedFiles: fileTypes,
      previewsContainer: '#dz-' + 'edit-preview-' + self.milestone_item.id,
      maxFiles: 1
    };

    var callbacks = {
      addedfile: function () {
        self.milestone_image_staged(true);
      },
      removedfile: function () {
        self.milestone_image_staged(false);
      },
      sending: function(file, xhr, formData) {
        Kadenze.UIUtil.showLoadingIndicator($container);
      },
      success: function(file, response) {
        if(response.files[0]) {
          file.id = response.files[0].id;
          self.milestone_item.attachment = response.files[0];
          self.milestone_item.attachment_id = file.id;
          self.milestone_item.content = file.name;
        }
      },
      error: function(file, errorMessage) {

      },
      complete: function(file) {
        Kadenze.UIUtil.hideLoadingIndicator($container);
      }
    };

    return Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);
  },
  resetStagedMilestone: function() {
    this.milestone_replace_image(false);
    this.milestone_image_staged(false);
    this.milestone_text_input('');
    this.milestone_date_input('');

    this.milestone_item = null;
    this.milestone_callback = null;

    if (this.milestone_text_input.clearError)
      this.milestone_text_input.clearError();

    if (this.milestone_date_input.clearError)
      this.milestone_date_input.clearError();
  },
  showAddModal: function() {
    var self = this;
    var dz = null;
    var $modal = $(JST['templates/dynamic_fields/authoring/add_timeline_milestone_modal']({}));
    ko.applyBindingsWithValidation(self, $modal[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    $modal.on('shown.bs.modal', function (e) {
      dz = self.initImageAddDropZone();
    });

    $modal.on('hidden.bs.modal', function (e) {
      self.resetStagedMilestone();

      dz.destroy();
      $modal.remove();

      self.saveTimeline();
    });

    $modal.modal('show');

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function(event) {
      if (_.isEmpty(self.milestone_date_input())) {
        new Kadenze.Notice.error({ message: 'Please assign a date to the milestone.' });
      } else if (_.isEmpty(self.milestone_text_input()) && _.isEmpty(self.milestone_item.attachment)) {
        new Kadenze.Notice.error({ message: 'Please add an image or text for the milestone.' });
      } else {
        var saveMilestone = function () {
          self.milestone_item.content = self.milestone_text_input();
          self.milestone_item.start = moment(self.milestone_date_input(), self.datepicker_opts().format.toUpperCase()).toISOString();

          self.milestone_callback(self.milestone_item);
          $modal.modal('hide');
        };

        if (dz.getQueuedFiles().length > 0) {
          dz.processQueue();
          dz.on('success', function(file, response) {
            saveMilestone();
          });
        } else {
          saveMilestone();
        }
      }

      event.stopPropagation();
    });
  },
  showEditModal: function() {
    var self = this;
    var dz = null;
    var $modal = $(JST['templates/dynamic_fields/authoring/edit_timeline_milestone_modal']({}));
    ko.applyBindingsWithValidation(self, $modal[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    $modal.on('shown.bs.modal', function (e) {
      self.milestone_text_input(self.milestone_item.content);
      dz = self.initImageEditDropZone($modal);
    });

    $modal.on('hidden.bs.modal', function (e) {
      self.resetStagedMilestone();

      dz.destroy();
      $modal.remove();

      self.saveTimeline();
    });

    $modal.modal('show');

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function(event) {
      if (_.isEmpty(self.milestone_text_input()) && _.isEmpty(self.milestone_item.attachment)) {
        new Kadenze.Notice.error({ message: 'Please add an image or text for the milestone.' });
      } else {
        var saveMilestone = function () {
          self.milestone_item.content = self.milestone_text_input();
          self.milestone_item.start = moment(self.milestone_date_input(), self.datepicker_opts().format.toUpperCase()).toISOString();
          self.milestone_callback(self.milestone_item);
          $modal.modal('hide');
        };

        if (dz.getQueuedFiles().length > 0) {
          dz.processQueue();
          dz.on('success', function(file, response) {
            saveMilestone();
          });
        } else {
          saveMilestone();
        }
      }

      event.stopPropagation();
    });
  }
});

///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.MatrixField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.MatrixField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  columns: null,
  rows: null,
  multi_response: null,
  rating_scale: null,
  numerical_rating: null,
  na_column: null,
  addRow: function(item, event) {
    this.rows.push(ko.observable(''));
  },
  addColumn: function(item, event) {
    if (this.columns().length < 10) {
      this.columns.push(ko.observable(''));
    } else {
      new Kadenze.Notice.error({ message: 'Please limit the # of columns to 10' });
    }
  },
  deleteRow: function(item) {
    this.rows.remove(function(row) {
      return row === item;
    });
  },
  deleteColumn: function(item) {
    this.columns.remove(function(col) {
      return col === item;
    });
  },
  getItems: function(items) {
    var ko_items = [];
    if (items.length > 0) {
      for(var i = 0; i < items.length; i++) {
        ko_items.push(ko.observable(items[i]));
      }
    } else {
      ko_items.push(ko.observable(''));
    }
    return ko_items;
  },
  init: function(dom_id, fd, opts) {
    var self = this;
    var r = Kadenze.Util.objFromString;
    var columns = r(fd, 'columns', []);
    var ko_columns = this.getItems(columns);

    var rows = r(fd, 'rows', []);
    var ko_rows = this.getItems(rows);

    this.columns = ko.observableArray(ko_columns);
    this.rows = ko.observableArray(ko_rows);

    this.multi_response = ko.observable(r(fd, 'multi_response', false));
    this.rating_scale = ko.observable(r(fd, 'rating_scale', false));
    this.rating_scale.subscribe(function() {
      if (self.rating_scale()) {
        self.numerical_rating(true);
      }
    });
    this.numerical_rating = ko.observable(r(fd, 'numerical_rating', false));
    this.na_column = {
      enabled: ko.observable(r(fd, 'na_column.enabled', false)),
      label: ko.observable(r(fd, 'na_column.label', 'N/A'))
    };
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.ImageMatchingField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.ImageMatchingField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  questions: null,
  question_ids: null,
  answers: null,
  answer_ids: null,
  question_answer_ids: null,
  grading_format: null,
  init: function(dom_id, fd, opts) {
    var self = this;
    var r = Kadenze.Util.objFromString;

    this.questions = ko.observableArray(r(fd, 'questions', []));
    this.question_ids = ko.observableArray(r(fd, 'question_ids', []));
    this.answers = ko.observableArray(r(fd, 'answers', []));
    this.answer_ids = ko.observableArray(r(fd, 'answer_ids', []));
    this.question_answer_ids = ko.observable(r(fd, 'question_answer_ids', {}));
    this.grading_format = ko.observable(r(fd, 'grading_format', 'partial'));

    //Re-seed the question answer hash with observable arrays
    var qas = this.question_answer_ids();
    _.each(this.question_ids(), function(id) {
      qas[id] = _.isArray(qas[id]) ? ko.observableArray(qas[id]) : ko.observableArray([]);
    });
    this.question_answer_ids(qas);

    //Upload UX
    this.addingQuestion = ko.observable(false);
    this.showUI = ko.observable(true); //Hack to force ko to refresh the DOM

    //State variables
    this.question_text_input = ko.observable('');
    this.answer_text_input = ko.observable('');
    this.selected_question_id = ko.observable(_.isEmpty(this.questions()[0]) ? -1 : this.questions()[0].id);
    this.selected_question_id.subscribe(function(value) {
      if (value > -1) {
        self.addingQuestion(false);

        if (self.question_text_input.clearError)
          self.question_text_input.clearError();
      } else {
        self.addingQuestion(true);
      }
    });
    this.selected_question_id.valueHasMutated();

    this.selectedQuestion = ko.computed(function() {
      return _.find(self.questions(), function(question) {
        return question.id == self.selected_question_id();
      });
    });

    //Keep track of if matches have been selected for all questions
    this.matches_pending = ko.computed(function() {
      return _.isEmpty(self.question_answer_ids()) || _.any(_.values(self.question_answer_ids()), function(value) { return _.isEmpty(value()); });
    });
    this.matches_pending.extend({ equal: { params: false, message: 'Please make sure Set A is not empty and all items in Set A have at least one match selected from Set B.' } });

    //Lookout for changes in question ids and update question answer hash
    this.question_ids.subscribe(function(changes) {
      var qas = self.question_answer_ids();
      changes.forEach(function (change) {
        if (change.status === 'added') {
          qas[change.value] = ko.observableArray([]);
        } else if (change.status === 'deleted') {
          delete qas[change.value];
        }
      });
      self.question_answer_ids(qas);
    }, null, 'arrayChange');

    //Lookout for changes in questions and update question ids array
    this.questions.subscribe(function(changes) {
      changes.forEach(function (change) {
        if (change.status === 'added') {
          self.question_ids.push(change.value.id);
        } else if (change.status === 'deleted') {
          self.question_ids.remove(change.value.id);
        }
      });
    }, null, 'arrayChange');

    //Lookout for changes in answer ids and update question answer hash
    this.answer_ids.subscribe(function(changes) {
      var qas = self.question_answer_ids();
      changes.forEach(function (change) {
        if (change.status === 'deleted') {
          _.each(qas, function(values, key) {
            qas[key].remove(change.value.id);
          });
        }
      });
      self.question_answer_ids(qas);
    }, null, 'arrayChange');

    //Lookout for changes in answers and update answer ids array
    this.answers.subscribe(function(changes) {
      changes.forEach(function (change) {
        if (change.status === 'added') {
          self.answer_ids.push(change.value.id);
        } else if (change.status === 'deleted') {
          self.answer_ids.remove(change.value.id);
        }
      });
    }, null, 'arrayChange');
  },
  refreshUI: function() {
    this.showUI(false);
    this.showUI(true);
  },
  selectQuestion: function(item, index) {
    this.selected_question_id(item.id);
  },
  getSelectedQuestionAnswers: function() {
    var sa = null;
    if (this.selected_question_id() > -1 && this.question_answer_ids()[this.selected_question_id()]) {
      var selected_ids = this.question_answer_ids()[this.selected_question_id()]();
      if (!_.isEmpty(selected_ids) && selected_ids.length > 0) {
        sa = _.filter(this.answers(), function(answer) {
          return _.includes(selected_ids, answer.id);
        });
      }
    }
    return sa || [];
  },
  viewQuestion: function(item, event) {
    Kadenze.MediaFileActions.preview(ko.mapping.toJS(item, {ignore: ['name']}));
  },
  initImageAddDropZone: function(type) {
    var self = this;
    var $container = (type == 'question') ? $('#' + this.dom_id()) : $('#add-attachment-' + self.dom_id());
    var $dropArea = $('#dz-' + type + '-drop-' + this.dom_id());
    var fileTypes = '.jpg, .jpeg, .png, .gif';
    var message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.question_media_title'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    var opts = {
      autoProcessQueue: false,
      paramName: 'attachment[file]',
      acceptedFiles: fileTypes,
      previewsContainer: '#dz-' + type + '-preview-' + this.dom_id(),
      maxFiles: 1,
      cropOptions: {
        aspectRatio: 1,
        modalId: 'crop_modal'
      },
      container: $container
    };

    var callbacks = {
      sending: function(file, xhr, formData) {
        Kadenze.UIUtil.showLoadingIndicator($container);
      },
      success: function(file, response) {
        if(response.files[0]) {
          file.id = response.files[0].id;
          if (type == 'question') {
            self.questions.push(response.files[0]);
            self.selected_question_id(file.id);
          } else {
            self.answers.push(response.files[0]);
            $container.modal('hide');
          }
        }
      },
      error: function(file, errorMessage) {
        Kadenze.UIUtil.showNotice($('#' + item.dom_id()), {message: errorMessage}, 1000);
      },
      complete: function(file) {
        Kadenze.UIUtil.hideLoadingIndicator($container);
      }
    };

    return Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);
  },
  addText: function(type) {
    var self = this;
    var $question = $('#' + this.dom_id());
    var url = Kadenze.Routes.attachments_path();
    var method = 'POST';
    var input_observable = (type == 'question') ? this.question_text_input : this.answer_text_input;

    if (_.isEmpty(input_observable())) {
      input_observable.setError('This field is required.');
      input_observable.isModified(true);
    }

    if (input_observable.isValid()) {
      var data = {attachment: { data: {text: input_observable()} } };

      var request = Kadenze.UIUtil.makeRequest(url, method, data, $question, null,
        function(data, textStatus, xhr) { //Success
          if(data.files[0]) {
            var id = data.files[0].id;
            if (type == 'question') {
              self.questions.push(data.files[0]);
              self.selected_question_id(id);
            } else {
              self.answers.push(data.files[0]);
              $('#add-attachment-' + self.dom_id()).modal('hide');
            }
            input_observable('');
          }
        },
        function(xhr, textStatus, errorThrown) { //Error

        });
    }
  },
  initImageEditDropZone: function(attachment, callbacks) {
    var $dropArea = $('#dz-' + 'edit-drop-' + attachment.id);
    var fileTypes = '.jpg, .jpeg, .png, .gif';
    var message = JST['templates/dropzone-generic']( {
      title: Kadenze.I18n.t('drop_file_editor.image_file_title'),
      hideUpperTitle: true,
      fileTypes: fileTypes,
      dropFilesTitle: Kadenze.I18n.t('drop_file_editor.drop_file_title'),
      dragAndDrop: Kadenze.I18n.t('drop_file_editor.drag_and_drop'),
      browseFiles: Kadenze.I18n.t('drop_file_editor.browse_files'),
      dimentionLabel: Kadenze.I18n.t('drop_file_editor.dimensions_label'),
      maxFilesizeLabel: Kadenze.I18n.t('drop_file_editor.max_file_size'),
      fileTypesLabel: Kadenze.I18n.t('drop_file_editor.file_types'),
      optionalLable: Kadenze.I18n.t('drop_file_editor.optional'),
    }
    );

    var opts = {
      url: Kadenze.Routes.attachment_path(attachment.id),
      method: 'PUT',
      autoProcessQueue: true,
      paramName: 'attachment[file]',
      acceptedFiles: fileTypes,
      previewsContainer: '#dz-' + 'edit-preview-' + attachment.id,
      maxFiles: 1
    };

    return Kadenze.MediaDropZone($dropArea, $(message), opts, callbacks, true);
  },
  showAddModal: function(item, event) {
    var self = this;
    var dz = null;
    var $modal = $(JST['templates/dynamic_fields/authoring/add_image_match_modal']({}));
    ko.applyBindingsWithValidation(self, $modal[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    $modal.on('shown.bs.modal', function (e) {
      dz = self.initImageAddDropZone('answer');
    });

    $modal.on('hidden.bs.modal', function (e) {
      if (self.answer_text_input.clearError)
        self.answer_text_input.clearError();

      $modal.remove();
    });

    $modal.modal('show');
  },
  showEditModal: function(attachment, type) {
    var self = this;
    var dz = null;
    var vm = ko.mapping.fromJS(attachment);
    var $modal = $(JST['templates/dynamic_fields/authoring/edit_image_match_modal']({}));
    ko.applyBindingsWithValidation(vm, $modal[0], Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS);

    $modal.on('shown.bs.modal', function (e) {
      if (!_.isEmpty(vm.file.url())) {
        var callbacks = {
          sending: function(file, xhr, formData) {
            Kadenze.UIUtil.showLoadingIndicator($modal);
          },
          success: function(file, response) {
            if(response.files[0]) {
              attachment.name = response.files[0].name;
              attachment.file = response.files[0].file;
              self.refreshUI();
              $modal.modal('hide');
            }
          },
          error: function(file, errorMessage) {

          },
          complete: function(file) {
            Kadenze.UIUtil.hideLoadingIndicator($modal);
          }
        };
        dz = self.initImageEditDropZone(attachment, callbacks);
      }
    });

    $modal.on('hidden.bs.modal', function (e) {
      if (!_.isEmpty(vm.file.url())) {
        dz.destroy();
      }

      $modal.remove();
    });

    $modal.modal('show');

    $modal.find('.js_delete').on('click', function() {
      var msg = I18n.t('js.slide_delete_message');
      var deleteAttachment = function() {
        //TODO: Delete the attachment from DB/S3 as well
        if (type == 'question') {
          self.selected_question_id(-1);
          self.questions.remove(attachment);
        } else {
          self.answers.remove(attachment);
        }
      };
      $modal.modal('hide');
      Kadenze.UIUtil.confirmAction(msg, deleteAttachment);
    });

    $modal.find('.js_cancel').on('click', function() {
      $modal.modal('hide');
    });

    $modal.find('.js_ok').on('click', function(event) {
      if (_.isEmpty(vm.file.url())) {
        if (vm.text_data.isValid()) {
          //Update DB
          attachment.data.text = vm.text_data();
          var url = Kadenze.Routes.attachment_path(attachment.id);
          var method = 'PATCH';
          var request = Kadenze.UIUtil.makeRequest(url, method, attachment, $modal, null,
            function(data, textStatus, xhr) { //Success
              attachment.text_data = vm.text_data(); //Update front-end
              self.refreshUI();
              $modal.modal('hide');
            },
            function(xhr, textStatus, errorThrown) { //Error

            });
        }
        event.stopPropagation();
      }
    });
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
FieldDefs.SectionBreakField = function() { FieldDefs.Base.prototype.init.apply(this, arguments); this.init.apply(this, arguments); };
FieldDefs.SectionBreakField.prototype = Kadenze.Util.extendClass(FieldDefs.Base, {
  message: null,
  init: function(dom_id, fd, opts) {
    var r = Kadenze.Util.objFromString;
    this.message = ko.observable(r(fd, 'message', ''));
  }
});
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default FieldDefs;

